import { useGenomeViewerStore } from "../../store/store.ts";
import { refreshMain } from "../render-main.ts";
import { handleScroll } from "./user-events-utils.ts";

/**
 * Moving the canvas with the arrow keys
 */
export function handleKeyDown(e: KeyboardEvent) {
  const state = useGenomeViewerStore.getState();
  if (state.zoomRange || state.disableKeyboardShortcuts) {
    return;
  }

  if (e.code === "Space") {
    useGenomeViewerStore.setState({
      asynchronousScrolling: true,
    });

    // We are drawing the tracks highlight-overlay
    refreshMain();
    e.preventDefault();
    return;
  }

  switch (e.key) {
    case "ArrowUp": {
      handleScroll(0, e.shiftKey ? -100 : -10);
      break;
    }
    case "ArrowDown": {
      handleScroll(0, e.shiftKey ? 100 : 10);
      break;
    }
    case "ArrowLeft": {
      handleScroll(e.shiftKey ? -100 : -10, 0);
      break;
    }
    case "ArrowRight": {
      handleScroll(e.shiftKey ? 100 : 10, 0);
      break;
    }
  }
}

/**
 * Disable the async scrolling of track groups
 */
export function handleKeyUp(e: KeyboardEvent) {
  if (e.code === "Space") {
    useGenomeViewerStore.setState({
      asynchronousScrolling: false,
    });

    // We are removing the tracks highlight-overlay
    refreshMain();
    e.preventDefault();
    return;
    // If ctrl key
  } else if (e.key === "Control") {
    useGenomeViewerStore.setState({
      zoomRange: undefined,
    });

    refreshMain();
    e.preventDefault();
    return;
  }
}
